import apiSlice from "./ApiSlice";

export const resourceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ADD
    addResource: builder.mutation({
      invalidatesTags: ["resource"],
      query: (body) => {
        return {
          url: "/resource/add",
          method: "POST",
          body,
        };
      },
    }),
    // GET
    getAllResources: builder.query({
      providesTags: ["resource"],
      query: (body) => {
        return {
          url: "/resource",
          method: "POST",
          body,
        };
      },
    }),

    // EDIT
    editResource: builder.mutation({
      invalidatesTags: ["resource"],
      query: ({ body, id }: any) => {
        return {
          url: `/resource/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    //Single View
    getResourceById: builder.query({
      providesTags: ["resource"],
      query: (id: any) => {
        return {
          url: `/resource/${id}`,
          method: "GET",
        };
      },
    }),

    // DELETE
    deleteResources: builder.mutation({
      invalidatesTags: ["resource"],
      query: ({ id }) => {
        return {
          url: `/resource/${id}`,
          method: "DELETE",
        };
      },
    }),
  }),
});

export const {
  useAddResourceMutation,
  useGetAllResourcesQuery,
  useEditResourceMutation,
  useGetResourceByIdQuery,
  useDeleteResourcesMutation
} = resourceApi;
